<template>
    <div>
        <div class="carousel_wrapper hidden-xs-only">
            <el-carousel :interval="2000" arrow="always" height="388px">
                <el-carousel-item v-for="(item, idx) in imgList" :key="idx">
                    <img :src="item.imgUrl" alt="" />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="carousel_wrapper_phone hidden-sm-and-up">
          <el-carousel :interval="2000" arrow="always" height="175px">
                <el-carousel-item v-for="(item, idx) in imgList" :key="idx">
                    <img :src="item.imgUrl" alt="" />
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgList: [
                {
                    imgUrl: require("../../../assets/img/banner.png"),
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/mixin.scss';
/* move */
.carousel_wrapper_phone {
  width: 100%;
  height: px2rem(175);
  img {
    width: 100%;
    height: px2rem(175);
  }
}
/* pc */
.carousel_wrapper {
    width: 100%;
    height: 388px;
    img {
        width: 100%;
        height: 388px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/iframepage/components/Carousel.vue